export default function PiSeperator() {
  return <div className="h-[2px] w-full bg-creator-border" />;
}
